if (!customElements.get('favorite-button')) {
  customElements.define(
    'favorite-button',
    class FavoriteButton extends HTMLElement {
      static STORAGE_KEY = 'flex:favorites';

      connectedCallback() {
        this.productId = this.dataset.productId;
        this.button = this.querySelector('.flex-favorite__button');
        this.button.addEventListener('click', this.onClick.bind(this));
        this.render(this.isFavorite());
      }

      onClick() {
        const nextState = !this.isFavorite();
        this.setFavorite(nextState);
        this.render(nextState);
      }

      isFavorite() {
        return this.readAll().includes(this.productId);
      }

      setFavorite(shouldFavorite) {
        const ids = this.readAll();
        const index = ids.indexOf(this.productId);

        if (shouldFavorite && index === -1) {
          ids.push(this.productId);
        } else if (!shouldFavorite && index !== -1) {
          ids.splice(index, 1);
        }

        try {
          window.localStorage.setItem(FavoriteButton.STORAGE_KEY, JSON.stringify(ids));
        } catch (error) {
          // localStorageが使用できない環境（プライベートブラウズ等）では見た目のトグルのみ行う
        }
      }

      readAll() {
        try {
          const raw = window.localStorage.getItem(FavoriteButton.STORAGE_KEY);
          const parsed = raw ? JSON.parse(raw) : [];
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return [];
        }
      }

      render(isFavorite) {
        this.button.setAttribute('aria-pressed', String(isFavorite));
        this.classList.toggle('is-active', isFavorite);
      }
    }
  );
}
